import React from 'react';
import PropTypes from 'prop-types';
import SFLoader from './SFLoader';
import css from './withLoader.scss';

// Refer to:
// https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
const getDisplayName = Component => Component.displayName || Component.name || 'Component';

export const withLoader = WrappedComponent => {

  class WithLoader extends React.Component {

    get wrappedComponentClass() {
      return this.props.loading ? css['hidden'] : null
    }

    render() {
      return <div className={css['loader-wrapper']}>
        {this.props.loading && <SFLoader>{this.props.loadingContent}</SFLoader>}
          <div className={this.wrappedComponentClass}><WrappedComponent{...this.props}/></div>
      </div>
    }

  }

  WithLoader.defaultProps = {
    loading: false
  };

  WithLoader.propTypes = {
    loadingContent: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    loading: PropTypes.bool
  };

  WithLoader.displayName = `WithLoader(${getDisplayName(WrappedComponent)})`;
  return WithLoader;
}
